"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../../../");

var _Context = require("./Context");

var _NavDropdown = require("./NavDropdown");

var _NavItem = _interopRequireDefault(require("./NavItem"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var CompactNav = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CompactNav, _React$Component);

  var _super = _createSuper(CompactNav);

  function CompactNav() {
    var _this;

    (0, _classCallCheck2["default"])(this, CompactNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      // currently expanded submenus
      expandedKeys: {}
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleSubmenuExpanded", function (key) {
      var subLinks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return function () {
        var _this$state$expandedK = _this.state.expandedKeys,
            expandedKeys = _this$state$expandedK === void 0 ? {} : _this$state$expandedK; // collapse submenu if already expanded, otherwise expand

        if (expandedKeys[key]) {
          delete expandedKeys[key]; // also collapse any expanded nested submenus

          subLinks.forEach(function (subLink) {
            delete expandedKeys[subLink.key];
          });
        } else {
          expandedKeys[key] = true;
        }

        _this.setState({
          expandedKeys: expandedKeys
        });
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onNavItemClick", function () {
      var onClose = _this.props.onClose;

      if (typeof onClose === 'function') {
        onClose();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(CompactNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeKey = _this$props.activeKey,
          _this$props$links = _this$props.links,
          links = _this$props$links === void 0 ? [] : _this$props$links,
          DefaultLinkWrapper = _this$props.LinkWrapper,
          inverted = _this$props.inverted,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["activeKey", "links", "LinkWrapper", "inverted"]);
      var _this$state$expandedK2 = this.state.expandedKeys,
          expandedKeys = _this$state$expandedK2 === void 0 ? {} : _this$state$expandedK2;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cloud-ui-nav compact trigger"
      }, /*#__PURE__*/_react["default"].createElement(_NavDropdown.NavDropdown, (0, _extends2["default"])({
        className: "cloud-ui-compact-nav",
        inverted: inverted,
        label: /*#__PURE__*/_react["default"].createElement("div", {
          className: "nav-icon-wrapper"
        }, /*#__PURE__*/_react["default"].createElement(_.Icon, {
          name: "menu"
        })),
        pinned: true,
        position: "bottom left",
        tooltip: "Navigation"
      }, rest), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "cloud-ui-nav vertical compact"
      }, links.map(function (_ref) {
        var key = _ref.key,
            href = _ref.href,
            label = _ref.label,
            icon = _ref.icon,
            _ref$LinkWrapper = _ref.LinkWrapper,
            LinkWrapper = _ref$LinkWrapper === void 0 ? DefaultLinkWrapper : _ref$LinkWrapper,
            _ref$links = _ref.links,
            subLinks = _ref$links === void 0 ? [] : _ref$links,
            linkProps = (0, _objectWithoutProperties2["default"])(_ref, ["key", "href", "label", "icon", "LinkWrapper", "links"]);
        var hasSub = subLinks.length > 0;
        var subExpanded = !!expandedKeys[key];
        var isSubItemActive = hasSub ? !!subLinks.find(function (l) {
          return l.key === activeKey || (l.links || []).find(function (sl) {
            return sl.key === activeKey;
          });
        }) : false;
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: key
        }, /*#__PURE__*/_react["default"].createElement(_NavItem["default"], (0, _extends2["default"])({}, linkProps, {
          href: href,
          icon: icon,
          isActive: isSubItemActive || activeKey === key,
          isOpen: subExpanded,
          LinkWrapper: LinkWrapper,
          onClick: hasSub ? _this2.toggleSubmenuExpanded(key, subLinks) : _this2.onNavItemClick
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "label"
        }, label), hasSub && /*#__PURE__*/_react["default"].createElement(_.Icon, {
          className: "sub-arrow down",
          name: "chevron-down"
        })), subLinks && /*#__PURE__*/_react["default"].createElement("ul", {
          className: (0, _classnames["default"])('nav-sub-list', {
            hidden: !subExpanded
          })
        }, subLinks.map(function (_ref2) {
          var subKey = _ref2.key,
              subHref = _ref2.href,
              label = _ref2.label,
              _ref2$LinkWrapper = _ref2.LinkWrapper,
              SubLinkWrapper = _ref2$LinkWrapper === void 0 ? LinkWrapper : _ref2$LinkWrapper,
              _ref2$links = _ref2.links,
              subSubLinks = _ref2$links === void 0 ? [] : _ref2$links,
              subLinkProps = (0, _objectWithoutProperties2["default"])(_ref2, ["key", "href", "label", "LinkWrapper", "links"]);
          var hasSubSub = subSubLinks.length > 0;
          var subSubExpanded = !!expandedKeys[subKey];
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: subKey
          }, /*#__PURE__*/_react["default"].createElement(_NavItem["default"], (0, _extends2["default"])({}, subLinkProps, {
            href: subHref,
            isActive: activeKey === subKey,
            LinkWrapper: SubLinkWrapper,
            isOpen: subSubExpanded,
            hasSub: hasSubSub,
            onClick: hasSubSub ? _this2.toggleSubmenuExpanded(subKey) : function () {
              var onClick = subLinkProps.onClick;

              if (typeof onClick === 'function') {
                onClick();
              }

              _this2.onNavItemClick();
            }
          }), label, subLinkProps.newTab && /*#__PURE__*/_react["default"].createElement(_.Icon, {
            name: "external-link-small"
          }), hasSubSub && /*#__PURE__*/_react["default"].createElement(_.Icon, {
            className: "sub-arrow down",
            name: "chevron-down"
          })), hasSubSub && /*#__PURE__*/_react["default"].createElement("ul", {
            className: (0, _classnames["default"])('nav-sub-list', {
              hidden: !subSubExpanded
            })
          }, subSubLinks.map(function (_ref3) {
            var subSubKey = _ref3.key,
                subSubLabel = _ref3.label,
                subHeading = _ref3.heading,
                _ref3$LinkWrapper = _ref3.LinkWrapper,
                SubSubLinkWrapper = _ref3$LinkWrapper === void 0 ? LinkWrapper : _ref3$LinkWrapper,
                subSubLinkProps = (0, _objectWithoutProperties2["default"])(_ref3, ["key", "label", "heading", "LinkWrapper"]);
            return /*#__PURE__*/_react["default"].createElement("li", {
              key: subSubKey
            }, /*#__PURE__*/_react["default"].createElement(_NavItem["default"], (0, _extends2["default"])({}, subSubLinkProps, {
              LinkWrapper: SubSubLinkWrapper,
              isActive: activeKey === subSubKey
            }), subSubLabel, subSubLinkProps.newTab && /*#__PURE__*/_react["default"].createElement(_.Icon, {
              name: "external-link-small"
            })));
          })));
        })));
      }))));
    }
  }]);
  return CompactNav;
}(_react["default"].Component);

var CompactNavWrapper = (0, _NavDropdown.withNavDropdownEvents)(CompactNav);

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_Context.ContextConsumer, null, function (_ref4) {
    var activeKey = _ref4.activeKey,
        links = _ref4.links,
        hasLinks = _ref4.hasLinks,
        LinkWrapper = _ref4.LinkWrapper;
    return hasLinks ? /*#__PURE__*/_react["default"].createElement(CompactNavWrapper, (0, _extends2["default"])({}, props, {
      activeKey: activeKey,
      links: links,
      LinkWrapper: LinkWrapper
    })) : null;
  });
};

exports["default"] = _default;